export default class DataLayerEnum {
    static WPET_LIST_ID = 'data-wpet-list-sit'
    static WPET_LIST_NAME = 'h1'
    static WPET_OFFER_CARD = '[data-wpet-wrapper="offer"] .iris-card'
    static WPET_OFFER_TITLE = 'data-layer-wpet-offer-title'
    static WPET_OFFER_ID_SIT = 'data-layer-wpet-offer-id'
    static WPET_OFFER_LOCATION = 'data-layer-wpet-offer-location'
    static WPET_OFFER_FLUX = 'data-layer-wpet-offer-flux'
}
